// jshint curly:true, maxdepth:5, unused:false
import app from 'app';
import 'm/UploadQueueModel';

app.namespace.Collection.UploadQueue = Backbone.Collection.extend({
  model: app.namespace.Model.UploadQueueModel,
  MAX_CONCURRENT_CHUNK_UPLOADS: 3,

  initialize() {
    /**
     * This instance is the queue of waiting for chunk-upload start (FIFO)
     */

    /**
     * Queue of chunk-upload in progress
     */
    this.chunkQueue = new Backbone.Collection();

    /**
     * Collection of unfinished uploads for monitoring
     * asset stays in unfinished collection until the requested number of upload stages passed
     * i.e. metadata->chunk, or metadata->chunk->transcoding->refresh
     * see UploadQueueModel options for more info
     */
    this.unfinished = new Backbone.Collection();

    /**
     * Keep track of the number of failed uploads during continuous upload session (bulk upload)
     * @type {number}
     */
    this.failedCount = 0;
  },

  upload(model) {
    console.log('UploadQueue->upload', model.attributes);

    if (this.unfinished.isEmpty()) {
      // started individual/bulk upload
      this.failedCount = 0;
    }

    this.unfinished.push(model);

    if (this.chunkQueue.length < this.MAX_CONCURRENT_CHUNK_UPLOADS) {
      // start upload of newly added asset only if `chunkQueue` collection is not full
      this._next(model);
    } else {
      // postpone
      this.push(model);
    }
  },

  _next(model) {
    this.chunkQueue.push(model);

    this.listenToOnce(model, 'error upload.finished.chunks', (model) => {
      // start next file upload as soon as error occurs or chunk upload finished
      this.chunkQueue.remove(model);

      if (!this.isEmpty()) {
        this._next(this.shift());
      }
    });

    const cp = model.startUpload();
    cp.catch((error) => {
      console.error('UploadQueue->startUpload rejected', error);
      ++this.failedCount;
    });
    cp.finally(() => {
      // model finished all requested stages of upload or failed to do so
      this.unfinished.remove(model, { remove: true });

      if (this.unfinished.isEmpty()) {
        // finished bulk upload
        if (this.failedCount > 0) {
          app.notificationController.push({
            text: `Oops\u2026 <b>${this.failedCount}</b> of your files could not be uploaded.
 Please try again or contact support if the problem persists.`,
            type: 'ERROR',
            timeout: app.TIME.second(10),
          });
          this.failedCount = 0;
        }
      }
    });
  },

  getVisualQue() {
    return new Backbone.Collection(
      this.unfinished.filter((model) => {
        return model.get('type') !== app.assetType.AUDIO;
      })
    );
  },

  getBGMusicQue() {
    return new Backbone.Collection(
      this.unfinished.filter((model) => {
        return (
          model.get('metadata').assetSubType === app.mediaAssetSubType.BG_MUSIC
        );
      })
    );
  },

  isUploading(assetUUID) {
    return this.unfinished.find((model) => {
      return model.get('metadata').assetUUID === assetUUID;
    });
  },

  trackProcessingFinish(assetUUID, isNarration) {
    const rv = new _.ColdPromise();

    app.api.realTime
      .listenOnAsset(assetUUID, {
        timeout: app.TIME.minute(30),
        isNarration,
      })
      .then(() => {
        app.api.asset.fetch(assetUUID).then(
          (res) => {
            app.namespace.Controller.AssetController.parse(res);
            rv.resolve(res);
          },
          (res) => {
            rv.reject(res);
          }
        );
      }, rv.reject);

    rv.canceled(() => {
      app.api.realTime.cancelListenOnAsset(assetUUID);
    });

    return rv;
  },
});

export default app.namespace.Collection.UploadQueue;
